export default __webpack_public_path__ + "static/media/controlPageUp24.e2b1a815.svg";